import React, { Component } from "react";
import { useTranslation } from "react-i18next";
import { MessageService, LocalStorageService } from "../../../services";
import { RequestOTPView } from "../../views";

class RequestOTPAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingView: false,
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            showWarningRequesting: false,
            messageError: '',
            messageComplete: '',
            messageWarning: '',
            phoneNumber: '',
            focusedOTP: false,
            validationCode: '',
            userEmail: '',
            isValidatingCode: false
        }
    }

    user = {}
    url = process.env.REACT_APP_MIFIRMA_API
    inputOTP = React.createRef();

    messageService = new MessageService(this.url);
    localStorageService = new LocalStorageService()

    componentDidMount() {
        let messageError = this.props.t("requestOTPAction.error.info.user")
        try {
            this.user = this.localStorageService.getLocalStorageItem("user")
            let phoneNumber = this.user.cellphoneNumber
            let userEmail = this.user.email
            phoneNumber = (phoneNumber) ? phoneNumber.replaceAll(' ', '').trim() : ''
            this.setState({
                phoneNumber,
                userEmail
            })
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    window.location.replace(sendTo)
                }
            }, time || 4000)
        })
    }


    toggleCompletedRequesting = (time, sendInbox, path, message) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
            messageComplete: message || ''
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                    messageComplete: ''
                })
                if (sendInbox) {
                    window.location.reload();
                }
            }, time || 4000)
        })
    }

    toggleWarningRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showWarningRequesting: true,
            messageWarning: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showWarningRequesting: false,
                    messageWarning: ''
                })
                if (sendInbox) {
                    window.location.replace(sendTo)
                }
            }, time || 4000)
        })
    }

    handleClickOTP = () => {
        this.inputOTP.current.focus();
    };

    handleFocusOTP = () => {
        this.setState({
            focusedOTP: true
        });
    };

    handleBlurOTP = () => {
        this.setState({
            focusedOTP: false,
        });
    };

    handleChangeOTP = (e) => {
        const value = e.target.value;
        const CODE_LENGTH = new Array(6).fill(0);

        if (this.state.validationCode.length >= CODE_LENGTH.length) return null
        let validationCode = (this.state.validationCode + value).slice(0, CODE_LENGTH.length)

        this.setState({
            validationCode
        })
    };

    handleKeyUpOTP = (e) => {
        if (e.key === "Backspace") {
            this.setIsValidating(false)
            let validationCode = (this.state.validationCode.slice(0, this.state.validationCode.length - 1))
            this.setState({
                validationCode
            })
            return
        }

        if (this.state.validationCode.length === 6) {
            this.handleValidateCode()
        }
    };

    resendSMSOrEmail = async (e, notificationTypeNumberorMail) => {
        this.toggleLoadingRequesting(true)
        let errorMessage = this.props.t("requestOTPAction.error.resend.message")
        let email = this.user.email
        let validationType = 'LOGIN'
        let notificationType = 'mail'
        //Si se necesita cambiar a que sea por sms o por email hay que pasarle el parametro notificationTypeNumberorMail,por el momento siempre va a ser por correo
        try {
            let sendMessage = await this.messageService.reSendMessageOrEmail(validationType, notificationType, email)
            if (sendMessage && sendMessage.data && Number(sendMessage.statusCode) === 200) {
                // let messageComplete = (validationType === 'mail') ? this.props.t("registration.action.resendMessageEmail") : this.props.t("registration.action.resendMessageSMS")
                let messageComplete = this.props.t("registration.action.resendMessageEmail")
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, "/", messageComplete)
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(errorMessage, 4000, false, "/")
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(errorMessage, 4000, false, "/")
        }
    }

    handleBackView = () => {
        window.location.reload()
    }

    handleValidateCode = async () => {
        if(this.state.isValidatingCode) return
        this.setIsValidating(true)
        let messageError = this.props.t("requestOTPAction.error.validation.code")
        this.toggleLoadingRequesting(true)
        try {
            let code = this.state.validationCode
            let email = this.user.email
            let validateCode = await this.messageService.validateCodeLogin(email, code)
            if (!validateCode || !validateCode.data || Number(validateCode.statusCode) !== 200) throw new Error(messageError)
            if (validateCode.data.codeIsCorrect) {
                this.setIsValidating(false)
                this.localStorageService.deleteElementLocalStorage("requestOTP");
                let messageComplete = this.props.t("requestOTPAction.message.code.correct")
                this.toggleLoadingRequesting(false)
                let token = (validateCode.data && validateCode.data.token) ? validateCode.data.token : null
                this.localStorageService.setLocalStorageItem("token", token)
                // this.toggleCompletedRequesting(4000, true, "/", messageComplete)
                window.location.reload()
            } else {
                this.setIsValidating(false)
                messageError = this.props.t("requestOTPAction.error.code.incorrect")
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (error) {
            this.setIsValidating(false)
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    setIsValidating = (value) => {
        this.setState({
            isValidatingCode: value
        })
    }

    render() {
        return (
            <RequestOTPView
                {...this.state}
                {...this.props}
                inputOTP={this.inputOTP}

                handleClickOTP={this.handleClickOTP}
                handleFocusOTP={this.handleFocusOTP}
                handleBlurOTP={this.handleBlurOTP}
                handleChangeOTP={this.handleChangeOTP}
                handleKeyUpOTP={this.handleKeyUpOTP}
                resendSMSOrEmail={this.resendSMSOrEmail}
                handleBackView={this.handleBackView}
                handleValidateCode={this.handleValidateCode}

                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
            />
        )
    }
}

const RequestOTPActionContainer = (props) => {
    let { t } = useTranslation()
    return (
        <RequestOTPAction
            {...props}
            t={t}
        />
    )
}
export { RequestOTPActionContainer as default }